// src/HomePage/Game/FolkGame/OAnQuan/OAnQuanWaitingRoom.js
import React from 'react';
import './OAnQuanWaitingRoom.css';

const OAnQuanWaitingRoom = ({ room, currentUser, onToggleReady, onKickPlayer, onLeave }) => {
  const getPlayerName = (player) => {
    if (!player) return '';
    const holy = player.holyName ? `${player.holyName} ` : '';
    const full = player.fullName || player.name || 'Người chơi';
    return `${holy}${full}`.trim();
  };

  const isHost = room.player1?.id === currentUser?.id;
  const myReadyStatus = isHost ? room.player1?.ready : room.player2?.ready;

  return (
    <div className="oanquan-wait-wrapper">
      <div className="oanquan-wait-header">
        <button className="oanquan-wait-leave-btn" onClick={onLeave}>
          {isHost && !room.player2 ? '⬅️ Hủy Bàn' : '⬅️ Rời Bàn'}
        </button>
        <div className="oanquan-wait-title-box">
          <h3>{room.name}</h3>
          <span className="oanquan-wait-status-tag">⏳ Chờ sẵn sàng</span>
        </div>
      </div>

      <div className="oanquan-wait-card">
        {/* Player 1 (Host) */}
        <div className={`oanquan-wait-player ${room.player1?.ready ? 'is-ready' : ''}`}>
          <div className="oanquan-wait-avatar">{room.player1?.avatar || '🎓'}</div>
          <span className="oanquan-wait-name">{getPlayerName(room.player1)}</span>
          <span className="oanquan-wait-role">Chủ Bàn (Dân 1)</span>
          <span className={`oanquan-wait-pill ${room.player1?.ready ? 'ready' : 'not-ready'}`}>
            {room.player1?.ready ? '✅ ĐÃ SẴN SÀNG' : '⏳ CHƯA SẴN SÀNG'}
          </span>
        </div>

        <div className="oanquan-wait-vs">VS</div>

        {/* Player 2 */}
        <div className={`oanquan-wait-player ${room.player2?.ready ? 'is-ready' : ''}`}>
          <div className="oanquan-wait-avatar">
            {room.player2 ? (room.player2.avatar || '🎓') : '⏳'}
          </div>
          <span className="oanquan-wait-name">
            {room.player2 ? getPlayerName(room.player2) : 'Đang đợi đối thủ vào...'}
          </span>
          <span className="oanquan-wait-role">{room.player2 ? 'Đối Thủ (Dân 2)' : 'Vị trí trống'}</span>

          {room.player2 && (
            <span className={`oanquan-wait-pill ${room.player2?.ready ? 'ready' : 'not-ready'}`}>
              {room.player2?.ready ? '✅ ĐÃ SẴN SÀNG' : '⏳ CHƯA SẴN SÀNG'}
            </span>
          )}

          {/* Nút Kick dành cho Chủ phòng */}
          {isHost && room.player2 && (
            <button
              className="oanquan-wait-kick-btn"
              onClick={onKickPlayer}
              title="Mời người này ra khỏi bàn"
            >
              Mời ra 🚫
            </button>
          )}
        </div>
      </div>

      <div className="oanquan-wait-action-area">
        <button
          className={`oanquan-wait-ready-btn ${myReadyStatus ? 'active' : ''}`}
          onClick={onToggleReady}
          disabled={!room.player2}
        >
          {!room.player2
            ? 'Đang chờ đối thủ vào phòng...'
            : myReadyStatus
            ? '✕ Hủy Sẵn Sàng'
            : '✔️ Bấm Sẵn Sàng'}
        </button>
        <p className="oanquan-wait-hint">💡 Khi cả hai cùng bấm Sẵn Sàng, trận đấu sẽ tự động bắt đầu ngay!</p>
      </div>
    </div>
  );
};

export default OAnQuanWaitingRoom;